import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import OnboardingPage from './pages/OnboardingPage';
import MatchesPage from './pages/MatchesPage';
import ProfilePage from './pages/ProfilePage';
import { TesterGuide } from './pages/TesterGuide';
import { AdminDashboard } from './pages/AdminDashboard';
import { LoneStayPage } from './pages/LoneStayPage';
import { ListingsPage } from './pages/ListingsPage';
import { DeveloperDashboard } from './pages/DeveloperDashboard';
import { EventsPage } from './pages/EventsPage';
import { FurniturePickupPage } from './pages/FurniturePickupPage';
import { ContractsPage } from './pages/ContractsPage';
import { Navigation } from './components/Navigation';
import { ActiveStatusCheck } from './components/ActiveStatusCheck';
import { ConnectionStatus } from './components/ConnectionStatus';
import { ApplicationStatus } from './components/ApplicationStatus';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <ActiveStatusCheck />
      <ConnectionStatus />
      <ApplicationStatus />
      <div className="min-h-screen bg-cream-200 md:pl-64">
        <Navigation />
        <main className="min-h-screen p-4 md:p-6">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            
            {/* Protected Routes */}
            <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
            <Route path="/matches" element={<ProtectedRoute><MatchesPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/guide" element={<ProtectedRoute><TesterGuide /></ProtectedRoute>} />
            <Route path="/lonestay" element={<ProtectedRoute><LoneStayPage /></ProtectedRoute>} />
            <Route path="/listings" element={<ProtectedRoute><ListingsPage /></ProtectedRoute>} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/dev" element={<ProtectedRoute requiredRole="admin"><DeveloperDashboard /></ProtectedRoute>} />
            <Route path="/events" element={<ProtectedRoute requiredRole="admin"><EventsPage /></ProtectedRoute>} />
            <Route path="/pickup" element={<ProtectedRoute requiredRole="admin"><FurniturePickupPage /></ProtectedRoute>} />
            <Route path="/contracts" element={<ProtectedRoute requiredRole="admin"><ContractsPage /></ProtectedRoute>} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;